import { AppBar, Box, GlobalStyles, Toolbar, Tooltip, useMediaQuery, useTheme } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	LabelPosition,
	RHookFormDatePicker,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";
import { FC, useEffect } from "react";

import { IAppState } from "../../../store/reducers";
import InfoIcon from '@mui/icons-material/Info';
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { formatDateToShow } from "../../../common/Common";
import { useSelector } from "react-redux";

export interface ICalculatedPayrollSetupToolbar {
	// onSubmitCalculatedPayrollButtonClickedHandler: () => void;
	onSubmitOrOverWriteCalculatedPayrollButtonClickedHandler: (selectedItem: any) => void;
	onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler: (selectedItem: any) => void;
	onEditCalculatedPayrollButtonClicked: () => void;
	onEmailStubCalculatedPayrollButtonClicked: (selectedItem: any) => void;
	onProcessPayrollClicked: () => void;
	onCancelProcessPayrollClicked: () => void;
	onSetPaymentDateClicked: () => void;
	payrollNonCalculatedDataItems: any;
	selectedPayPeriod: any
	payPeriodEndDate: any
	payPeriodStartDate: any
	companyInfo: any;
	calculatedPayrollTableData: any
	formMethods: any
	openRollbackDialogue?: any
	clientBankDDL: any;
	gridsMaxTotalWidth?: any
}

const isDateBetween = (
	target: string,
	start: string,
	end: string
): boolean => {
	const targetDate = new Date(target);
	const startDate = new Date(start);
	const endDate = new Date(end);

	return targetDate >= startDate && targetDate <= endDate;
};

export const CalculatedPayrollSetupToolbar: FC<ICalculatedPayrollSetupToolbar> = ({
	// onSubmitCalculatedPayrollButtonClickedHandler,
	onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler,
	onEditCalculatedPayrollButtonClicked,
	onEmailStubCalculatedPayrollButtonClicked,
	onSubmitOrOverWriteCalculatedPayrollButtonClickedHandler,
	onProcessPayrollClicked,
	payrollNonCalculatedDataItems,
	onCancelProcessPayrollClicked,
	selectedPayPeriod,
	payPeriodEndDate,
	payPeriodStartDate,
	companyInfo,
	calculatedPayrollTableData,
	onSetPaymentDateClicked,
	formMethods,
	openRollbackDialogue,
	clientBankDDL,
	gridsMaxTotalWidth
}) => {
	const isAdminUser = useSelector((state: IAppState) => state.user.profile.isSuperStatus)
	let companyBillingStartDate = companyInfo.billingStartDate ? new Date(companyInfo.billingStartDate) : null;
	const startDate = new Date(payPeriodStartDate);
	const endDate = new Date(payPeriodEndDate);
	// const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate >= startDate && companyBillingStartDate <= endDate
	const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate <= endDate;


	useEffect(() => {
		if (selectedPayPeriod && selectedPayPeriod.process && selectedPayPeriod.processPaymentDate) {
			formMethods.setValue('paymentDate', new Date(selectedPayPeriod.processPaymentDate))
		}
	}, [selectedPayPeriod])

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
	const mobileTabOrSmallLaptopScreen = isMobile || isSmallScreen;

	return (
		<div style={{ width: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", minWidth: gridsMaxTotalWidth && gridsMaxTotalWidth !== 0 ? `${gridsMaxTotalWidth}px` : "100%", backgroundColor: "#fff", }}>
			<div
				style={{
					position: "sticky",
					left: !mobileTabOrSmallLaptopScreen ? 250 : 0,
					width: "fit-content",
					// zIndex: 5,
					backgroundColor: "#fff",
				}}
			>
				<AppBar
					position="sticky"
					color="default"
					elevation={1}
					data-testId={""}
					sx={{
						backgroundColor: "#fff",
						boxShadow: "none",
						alignItems: "center",
						display: "grid",
						gridTemplateColumns: "1fr auto 1fr",
						paddingBottom: ".5rem"
					}}
				>
					<div />
					<Toolbar sx={{ justifySelf: "center" }}>
						<SplitButton
							options={["Print Check / Stub", "Print Stub Only", "Print Check Only"]}
							onClickHandler={onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler}
							testId="t4-print-button"
						/>
						<EnhancedButtonPrimeReact
							// icon="pi pi-trash"
							label="Edit"
							raised
							onClickHandler={onEditCalculatedPayrollButtonClicked}
							style={{ marginLeft: "1rem", marginRight: "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Danger}
							disabled={!openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process ? true : false}
						/>
						{/* <EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSubmitCalculatedPayrollButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/> */}
						{/* {selectedPayPeriod && selectedPayPeriod.process ? */}
						{/* <EnhancedButtonPrimeReact
					label="Save"
					raised
					onClickHandler={() => onSubmitOrOverWriteCalculatedPayrollButtonClickedHandler('Save')}
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>: */}
						<>
							<GlobalStyles styles={{
								"#split-button-menu .MuiButtonBase-root:nth-of-type(2)": {
									opacity: !openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process ? "0.5 !important" : 1,
									cursor: !openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process ? "not-allowed !important" : "pointer",
									pointerEvents: !openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process ? "none !important" : "auto",
								}
							}} />
							<SplitButton
								options={["Save", "Overwrite"]}
								onClickHandler={onSubmitOrOverWriteCalculatedPayrollButtonClickedHandler}
								testId="t4-print-button"
							/></>
						{/* } */}
						<span>&nbsp;&nbsp;&nbsp;</span>
						<SplitButton
							options={["Email Stub", "Email Timesheet"]}
							onClickHandler={onEmailStubCalculatedPayrollButtonClicked}
							testId="t4-print-button"
						/>
						{!openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process ? <EnhancedButtonPrimeReact
							label="Cancel Payroll"
							raised
							onClickHandler={onCancelProcessPayrollClicked}
							style={{ marginLeft: "1rem" }}
							severity={EnhancedButtonPrimeReactSeverity.Danger}
							disabled={
								calculatedPayrollTableData && !calculatedPayrollTableData.transactionReadyState ||
								calculatedPayrollTableData && calculatedPayrollTableData.summary.nextPeriodData ||
								calculatedPayrollTableData && calculatedPayrollTableData.summary.checkCraRemitted
							}
						/> : isCompanyBillingStartDateLiesBetweenLoadedPeriod && <EnhancedButtonPrimeReact
							label="Process Payroll Now"
							raised
							onClickHandler={onProcessPayrollClicked}
							style={{ marginLeft: "1rem" }}
							disabled={
								payrollNonCalculatedDataItems && payrollNonCalculatedDataItems.length > 0 ? true :
									calculatedPayrollTableData && !calculatedPayrollTableData.haveBank ? true :
										(
											clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
											clientBankDDL?.client_bank_ddl.length === 0
										) ? true : (
											clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
											clientBankDDL?.client_bank_ddl?.some((bank: any) => bank.status !== 100)
										) ? true :
											false
							}
						/>}

						{/* umair ny krwaya ha ye  */}
						{(
							clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
							clientBankDDL?.client_bank_ddl.length === 0
						) || (
								clientBankDDL?.client_details_for_payroll?.paymentSetup === 200 &&
								clientBankDDL?.client_bank_ddl?.some((bank: any) => bank.status !== 100)
							) ? <Tooltip title={"Comapny bank details are missing"} placement={"top"}>
							<InfoIcon
								sx={{
									fontSize: "1.1rem",
									margin: "5px 4px 4px 4px",
									cursor: "pointer",
								}}
							/>
						</Tooltip> : <></>}

						{!openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process && isAdminUser !== 400 &&
							<span
								style={{
									fontSize: "0.875rem",
									fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
									fontWeight: 500,
									letterSpacing: "0.00714em",
									// color: "rgba(0, 0, 0, 0.6)",
									color: "#ef4444",
									marginLeft: "1rem"
								}}>
								Payment Date: <b>{formatDateToShow(payPeriodEndDate)}</b>
							</span>}
					</Toolbar>
					{!openRollbackDialogue && selectedPayPeriod && selectedPayPeriod.process && selectedPayPeriod.processPaymentDate && isAdminUser === 400 &&
						<Box sx={{
							display: "block",
							alignItems: "center",
							justifySelf: "end", pr: "1rem", mb: "1rem"
						}}>
							<Box sx={{
								width: "172px", mt: "2px", ml: "1rem", "& .calenderWrapper": { marginBottom: "0!important" }, "& .MuiFormLabel-root": {
									fontSize: ".875rem!important",
									// color: "#ef4444",
									fontWeight: "bold"
								},
								display: "flex"
							}}>
								<RHookFormDatePicker
									name="paymentDate"
									testId="Payment-Date"
									label="Payment Date"
									format="M dd, yy"
									defaultValue={new Date(selectedPayPeriod.processPaymentDate)}
								/>
							</Box>
							<EnhancedButtonPrimeReact
								label="Set Payment Date"
								raised
								onClickHandler={onSetPaymentDateClicked}
								style={{ marginLeft: "1rem" }}
								severity={EnhancedButtonPrimeReactSeverity.Secondary}
							/>
						</Box>}
				</AppBar></div></div>
	);
};
